module.exports = __webpack_public_path__ + "img/vimeo.894ce2e5.svg";